import React from "react";

import styles from './loginbackground.module.scss'
import cx from "classnames";

const backgroundVideo = "/images/signin/loginbg.mp4";

const BackgroundV1 = () => {
  const backgroundPosition =
    (backgroundVideo ? backgroundVideo.position : null) || "center center";

  const style = {
    objectPosition: backgroundPosition,
    position: 'fixed',
    top:0,
    bottom:0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',

  };

  return (
    <div className={styles.background}>
      <video
        ref={(node) => node}
        className={cx(styles.video, backgroundPosition)}
        type="video/mp4"
        autoPlay
        playsInline
        muted
        loop
        style={style}
        key={backgroundVideo}
      >
        <source src={backgroundVideo} type="video/mp4" />
      </video> 

    </div>
  );
};

export { BackgroundV1 };
